// import React, { useState } from "react";
// import { Modal } from "react-bootstrap";
// import {
//   FaUserCircle,
//   FaFileAlt,
//   FaIdCard,
//   FaUser,
//   FaEye,
//   FaFilePdf,
//   FaDownload,
// } from "react-icons/fa";

// import "./ServitorDocuments.css"; // Updated CSS import

// const ServitorDocuments = ({ show, onHide, servitor }) => {
//   const [activeTab, setActiveTab] = useState("bio");

//   if (!servitor) return null;

//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="lg"
//       dialogClassName="ServitorDocuments-modal"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>
//           <FaUserCircle className="ServitorDocuments-modalIcon" />
//           Servitor Documents & Bio
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="ServitorDocuments-tabs">
//           <button
//             className={`ServitorDocuments-tabBtn ${activeTab === "bio" ? "ServitorDocuments-tabActive" : ""}`}
//             onClick={() => setActiveTab("bio")}
//           >
//             <FaUser className="ServitorDocuments-tabIcon" /> Bio
//           </button>
//           <button
//             className={`ServitorDocuments-tabBtn ${activeTab === "resume" ? "ServitorDocuments-tabActive" : ""}`}
//             onClick={() => setActiveTab("resume")}
//           >
//             <FaFileAlt className="ServitorDocuments-tabIcon" /> Resume
//           </button>
//           <button
//             className={`ServitorDocuments-tabBtn ${activeTab === "nid" ? "ServitorDocuments-tabActive" : ""}`}
//             onClick={() => setActiveTab("nid")}
//           >
//             <FaIdCard className="ServitorDocuments-tabIcon" /> NID Card
//           </button>
//         </div>
//         <div className="ServitorDocuments-documentViewer">
//           {activeTab === "bio" && (
//             <div className="ServitorDocuments-tabContent">
//               <div className="ServitorDocuments-bioContainer">
//                 <div className="ServitorDocuments-bioHeader">
//                   <div className="ServitorDocuments-avatar">
//                     {servitor.FirstName[0] + servitor.LastName[0]}
//                   </div>
//                   <div>
//                     <h4 className="ServitorDocuments-bioName">
//                       {servitor.FirstName} {servitor.LastName}
//                     </h4>
//                     <p className="ServitorDocuments-bioTitle">Professional Tutor</p>
//                   </div>
//                 </div>
//                 <div className="ServitorDocuments-aboutSection">
//                   <h5>About Me</h5>
//                   <p>
//                     I am a dedicated and experienced tutor with over 2 years of teaching experience. I specialize in providing comprehensive educational support to students of various levels. My teaching methodology focuses on understanding each student's unique learning style and adapting my approach accordingly. I have successfully helped numerous students achieve their academic goals.
//                   </p>
//                 </div>
//                 <div className="ServitorDocuments-sectionsGrid">
//                   <div className="ServitorDocuments-section">
//                     <h5>Specializations</h5>
//                     <ul>
//                       <li>• Mathematics (All Levels)</li>
//                       <li>• Physics & Chemistry</li>
//                       <li>• English Language</li>
//                       <li>• Computer Science</li>
//                     </ul>
//                   </div>
//                   {/* <div className="ServitorDocuments-section">
//                     <h5>Languages</h5>
//                     <ul>
//                       <li>• Bengali (Native)</li>
//                       <li>• English (Fluent)</li>
//                       <li>• Hindi (Conversational)</li>
//                     </ul>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//           )}
//           {activeTab === "resume" && (
//             <div className="ServitorDocuments-tabContent">
//               <div className="ServitorDocuments-resumeContainer">
//                 <div className="ServitorDocuments-fileMock">
//                   <FaFilePdf className="ServitorDocuments-pdfIcon" />
//                   <p className="ServitorDocuments-fileName">Resume.pdf</p>
//                   <p className="ServitorDocuments-fileSize">2.3 MB</p>
//                 </div>
//                 <div className="ServitorDocuments-actionButtons">
//                   <button className="ServitorDocuments-viewPdfBtn">
//                     <FaEye className="ServitorDocuments-btnIcon" /> View PDF
//                   </button>
//                   <button className="ServitorDocuments-downloadBtn">
//                     <FaDownload className="ServitorDocuments-btnIcon" /> Download
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//           {activeTab === "nid" && (
//             <div className="ServitorDocuments-tabContent">
//               <div className="ServitorDocuments-nidContainer">
//                 <div className="ServitorDocuments-nidHeader">
//                   <h5>National ID Card</h5>
//                   <p>NID: {servitor.NID}</p>
//                 </div>
//                 <div className="ServitorDocuments-nidCard">
//                   <div className="ServitorDocuments-nidCardHeader">
//                     <div>
//                       <h6>People's Republic of Bangladesh</h6>
//                       <p>National Identity Card</p>
//                     </div>
//                     <div className="ServitorDocuments-nidAvatar">
//                       <FaUser />
//                     </div>
//                   </div>
//                   <div className="ServitorDocuments-nidDetails">
//                     <div>
//                       <p>Name:</p>
//                       <p className="ServitorDocuments-nidValue">
//                         {servitor.FirstName} {servitor.LastName}
//                       </p>
//                     </div>
//                     <div>
//                       <p>NID No:</p>
//                       <p className="ServitorDocuments-nidValue">{servitor.NID}</p>
//                     </div>
//                     <div>
//                       <p>Father's Name:</p>
//                       <p className="ServitorDocuments-nidValue">Md. Abdul Rahman</p>
//                     </div>
//                     <div>
//                       <p>Date of Birth:</p>
//                       <p className="ServitorDocuments-nidValue">15 Mar 1995</p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="ServitorDocuments-nidAction">
//                   <button className="ServitorDocuments-viewFullBtn">
//                     <FaEye className="ServitorDocuments-btnIcon" /> View Full Document
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default ServitorDocuments;






// import React, { useState, useEffect } from "react";
// import { Modal } from "react-bootstrap";
// import {
//   FaUserCircle,
//   FaFileAlt,
//   FaIdCard,
//   FaUser,
//   FaEye,
//   FaFilePdf,
//   FaDownload,
// } from "react-icons/fa";
// import { URL } from "../../../config";
// import "./ServitorDocuments.css";

// /** Build a full URL from raw DB value */
// const buildFileUrl = (p) => {
//   if (!p || typeof p !== "string") return "";
//   if (/^https?:\/\//i.test(p)) return p;
//   if (p.startsWith("/uploads/")) return `${URL}${p}`;
//   if (p.startsWith("uploads/")) return `${URL}/${p}`;
//   return `${URL}/uploads/${p}`;
// };

// const filenameFromPath = (p) => {
//   if (!p || typeof p !== "string") return "file";
//   try {
//     const url = new URL(p);
//     const leaf = url.pathname.split("/").pop();
//     return (leaf && decodeURIComponent(leaf)) || "file";
//   } catch {
//     const leaf = p.split("/").pop();
//     return (leaf && decodeURIComponent(leaf)) || "file";
//   }
// };

// const isPdf = (u) => /\.pdf(\?|#|$)/i.test(u);
// const isImage = (u) => /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(u);

// const ServitorDocuments = ({ show, onHide, servitor, servitorId }) => {
//   const [activeTab, setActiveTab] = useState("bio");
//   const [fullServitor, setFullServitor] = useState(servitor || null);
//   const [loading, setLoading] = useState(false);
//   const [fetchErr, setFetchErr] = useState("");

//   useEffect(() => {
//     setFullServitor(servitor || null);
//   }, [servitor, servitorId]);

//   useEffect(() => {
//     if (!show) return;

//     const idToFetch = servitorId || servitor?.Id;
//     if (!idToFetch) return;

//     const endpoint = `${URL}/servitors/${idToFetch}`;
//     setLoading(true);
//     setFetchErr("");

//     fetch(endpoint)
//       .then(async (res) => {
//         if (!res.ok) {
//           const text = await res.text();
//           throw new Error(text || `Fetch failed: ${res.status}`);
//         }
//         return res.json();
//       })
//       .then((data) => setFullServitor(data))
//       .catch(() => setFetchErr("Failed to fetch servitor details."))
//       .finally(() => setLoading(false));
//   }, [show, servitorId, servitor?.Id]);

//   const bio = fullServitor?.bio || "";

//   const resumeRaw = fullServitor?.DOC || "";
//   const resumeUrl = buildFileUrl(resumeRaw);
//   const hasResume = !!resumeRaw;

//   const studentRaw =
//     fullServitor?.tutorProfile?.studentIdCard ||
//     fullServitor?.studentIdCard ||
//     "";
//   const studentUrl = buildFileUrl(studentRaw);
//   const hasStudentId = !!studentRaw;

//   const initials = `${fullServitor?.FirstName?.[0] || ""}${
//     fullServitor?.LastName?.[0] || ""
//   }`.toUpperCase();
//   const resumeName = filenameFromPath(resumeRaw || resumeUrl);
//   const studentName = filenameFromPath(studentRaw || studentUrl);

//   const openInNewTab = (url) => url && window.open(url, "_blank", "noopener,noreferrer");
//   const downloadFile = (url, filename = "download") => {
//     if (!url) return;
//     const a = document.createElement("a");
//     a.href = url;
//     a.setAttribute("download", filename);
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//   };

//   return (
//     <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="ServitorDocuments-modal">
//       <Modal.Header closeButton>
//         <Modal.Title>
//           <FaUserCircle className="ServitorDocuments-modalIcon" />
//           Servitor Documents &amp; Bio
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="ServitorDocuments-tabs">
//           <button
//             className={`ServitorDocuments-tabBtn ${
//               activeTab === "bio" ? "ServitorDocuments-tabActive" : ""
//             }`}
//             onClick={() => setActiveTab("bio")}
//           >
//             <FaUser className="ServitorDocuments-tabIcon" /> Bio
//           </button>
//           <button
//             className={`ServitorDocuments-tabBtn ${
//               activeTab === "resume" ? "ServitorDocuments-tabActive" : ""
//             }`}
//             onClick={() => setActiveTab("resume")}
//           >
//             <FaFileAlt className="ServitorDocuments-tabIcon" /> Resume
//           </button>
//           <button
//             className={`ServitorDocuments-tabBtn ${
//               activeTab === "student" ? "ServitorDocuments-tabActive" : ""
//             }`}
//             onClick={() => setActiveTab("student")}
//           >
//             <FaIdCard className="ServitorDocuments-tabIcon" /> Student&nbsp;ID
//           </button>
//         </div>

//         <div className="ServitorDocuments-documentViewer">
//           {loading && <div className="ServitorDocuments-loading">Loading…</div>}
//           {!loading && fetchErr && <div className="ServitorDocuments-error">{fetchErr}</div>}

//           {!loading && !fetchErr && activeTab === "bio" && (
//             <div className="ServitorDocuments-tabContent">
//               <div className="ServitorDocuments-bioContainer">
//                 <div className="ServitorDocuments-bioHeader">
//                   <div className="ServitorDocuments-avatar">{initials}</div>
//                   <div>
//                     <h4 className="ServitorDocuments-bioName">
//                       {fullServitor?.FirstName} {fullServitor?.LastName}
//                     </h4>
//                     <p className="ServitorDocuments-bioTitle">
//                       Professional {fullServitor?.service || "Servitor"}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="ServitorDocuments-aboutSection">
//                   <h5>About Me</h5>
//                   {bio ? (
//                     bio.split("\n").map((line, i) => (
//                       <p key={i} style={{ whiteSpace: "pre-wrap" }}>
//                         {line}
//                       </p>
//                     ))
//                   ) : (
//                     <p>No bio added yet.</p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {!loading && !fetchErr && activeTab === "resume" && (
//             <div className="ServitorDocuments-tabContent">
//               <div className="ServitorDocuments-resumeContainer">
//                 {hasResume ? (
//                   <>
//                     <div className="ServitorDocuments-fileMock">
//                       <FaFilePdf className="ServitorDocuments-pdfIcon" />
//                       <p className="ServitorDocuments-fileName">{resumeName}</p>
//                     </div>
//                     <div className="ServitorDocuments-actionButtons">
//                       <button
//                         className="ServitorDocuments-viewPdfBtn"
//                         onClick={() => openInNewTab(resumeUrl)}
//                       >
//                         <FaEye className="ServitorDocuments-btnIcon" /> View PDF
//                       </button>
//                       <button
//                         className="ServitorDocuments-downloadBtn"
//                         onClick={() => downloadFile(resumeUrl, resumeName)}
//                       >
//                         <FaDownload className="ServitorDocuments-btnIcon" /> Download
//                       </button>
//                     </div>
//                     {isPdf(resumeUrl) && (
//                       <div className="ServitorDocuments-inlinePreview">
//                         <iframe
//                           src={resumeUrl}
//                           title="Resume Preview"
//                           className="ServitorDocuments-iframe"
//                         />
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <p>No resume uploaded.</p>
//                 )}
//               </div>
//             </div>
//           )}

//           {!loading && !fetchErr && activeTab === "student" && (
//             <div className="ServitorDocuments-tabContent">
//               <div className="ServitorDocuments-nidContainer">
//                 <div className="ServitorDocuments-nidHeader">
//                   <h5>Student ID Card</h5>
//                 </div>

//                 {hasStudentId ? (
//                   <>
//                     <div className="ServitorDocuments-nidCard">
//                       {isImage(studentUrl) ? (
//                         <img
//                           src={studentUrl}
//                           alt="Student ID"
//                           className="ServitorDocuments-nidPreviewImg"
//                         />
//                       ) : isPdf(studentUrl) ? (
//                         <div className="ServitorDocuments-inlinePreview">
//                           <iframe
//                             src={studentUrl}
//                             title="Student ID Preview"
//                             className="ServitorDocuments-iframe"
//                           />
//                         </div>
//                       ) : (
//                         <div className="ServitorDocuments-fileMock">
//                           <FaFilePdf className="ServitorDocuments-pdfIcon" />
//                           <p className="ServitorDocuments-fileName">{studentName}</p>
//                         </div>
//                       )}
//                     </div>
//                     <div className="ServitorDocuments-nidAction">
//                       <button
//                         className="ServitorDocuments-viewFullBtn"
//                         onClick={() => openInNewTab(studentUrl)}
//                       >
//                         <FaEye className="ServitorDocuments-btnIcon" /> View Full
//                       </button>
//                       <button
//                         className="ServitorDocuments-downloadBtn"
//                         onClick={() => downloadFile(studentUrl, studentName)}
//                       >
//                         <FaDownload className="ServitorDocuments-btnIcon" /> Download
//                       </button>
//                     </div>
//                   </>
//                 ) : (
//                   <p>No student ID card uploaded.</p>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default ServitorDocuments;






import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import {
  FaUserCircle,
  FaFileAlt,
  FaIdCard,
  FaUser,
  FaEye,
  FaFilePdf,
  FaDownload,
  FaUserGraduate,
} from "react-icons/fa";
import { URL as API_URL } from "../../../config";
import "./ServitorDocuments.css";

/** Build a full URL from raw DB value */
const buildFileUrl = (p) => {
  if (!p || typeof p !== "string") return "";
  if (/^https?:\/\//i.test(p)) return p;
  if (p.startsWith("/uploads/")) return `${API_URL}${p}`;
  if (p.startsWith("uploads/")) return `${API_URL}/${p}`;
  return `${API_URL}/uploads/${p}`;
};

const filenameFromPath = (p) => {
  if (!p || typeof p !== "string") return "file";
  try {
    const url = new window.URL(p);
    const leaf = url.pathname.split("/").pop();
    return (leaf && decodeURIComponent(leaf)) || "file";
  } catch {
    const leaf = p.split("/").pop();
    return (leaf && decodeURIComponent(leaf)) || "file";
  }
};

const isPdf = (u) => /\.pdf(\?|#|$)/i.test(u);
const isImage = (u) => /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(u);

const ServitorDocuments = ({ show, onHide, servitor, servitorId }) => {
  const [activeTab, setActiveTab] = useState("bio");
  const [fullServitor, setFullServitor] = useState(servitor || null);
  const [loading, setLoading] = useState(false);
  const [fetchErr, setFetchErr] = useState("");
  const [downloading, setDownloading] = useState({ resume: false, student: false });

  useEffect(() => {
    setFullServitor(servitor || null);
  }, [servitor, servitorId]);

  useEffect(() => {
    if (!show) return;

    const idToFetch = servitorId || servitor?.Id;
    if (!idToFetch) return;

    const endpoint = `${API_URL}/servitors/${idToFetch}`;
    setLoading(true);
    setFetchErr("");

    fetch(endpoint)
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || `Fetch failed: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => setFullServitor(data))
      .catch(() => setFetchErr("Failed to fetch servitor details."))
      .finally(() => setLoading(false));
  }, [show, servitorId, servitor?.Id]);

  const bio = fullServitor?.bio || "";

  // const resumeRaw = fullServitor?.DOC || "";
  const resumeRaw = fullServitor?.tutorProfile?.resume || "";
  const resumeUrl = buildFileUrl(resumeRaw);
  const hasResume = !!resumeRaw;

  const studentRaw =
    fullServitor?.tutorProfile?.studentIdCard ||
    fullServitor?.studentIdCard ||
    "";
  const studentUrl = buildFileUrl(studentRaw);
  const hasStudentId = !!studentRaw;

  const initials = `${fullServitor?.FirstName?.[0] || ""}${fullServitor?.LastName?.[0] || ""}`.toUpperCase();
  const resumeName = filenameFromPath(resumeRaw || resumeUrl);
  const studentName = filenameFromPath(studentRaw || studentUrl);

  const universityName = fullServitor?.tutorProfile?.universityName || "";
  const major = fullServitor?.tutorProfile?.major || "";

  const openInNewTab = (url) => url && window.open(url, "_blank", "noopener,noreferrer");

  /** Robust downloader: fetch → blob → objectURL → <a download> click → revoke */
  const downloadFile = async (url, filename, key) => {
    if (!url) return;
    try {
      if (key) setDownloading((d) => ({ ...d, [key]: true }));

      const res = await fetch(url, { method: "GET" });
      if (!res.ok) throw new Error(`Download failed: ${res.status}`);

      const cd = res.headers.get("content-disposition");
      let finalName = filename || "download";
      if (cd) {
        const m = cd.match(/filename\*?=(?:UTF-8''|")?([^";\n]+)/i);
        if (m && m[1]) finalName = decodeURIComponent(m[1].replace(/"/g, ""));
      }

      const ct = res.headers.get("content-type") || "";
      if (!/\.[a-z0-9]{2,5}$/i.test(finalName)) {
        if (ct.includes("pdf")) finalName += ".pdf";
        else if (ct.includes("png")) finalName += ".png";
        else if (ct.includes("jpeg") || ct.includes("jpg")) finalName += ".jpg";
      }

      const blob = await res.blob();
      const blobUrl = (window.URL || window.webkitURL).createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = finalName;
      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(() => (window.URL || window.webkitURL).revokeObjectURL(blobUrl), 1000);
    } catch (e) {
      console.error(e);
      openInNewTab(url);
    } finally {
      if (key) setDownloading((d) => ({ ...d, [key]: false }));
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="ServitorDocuments-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <FaUserCircle className="ServitorDocuments-modalIcon" />
          Servitor Documents &amp; Bio
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="ServitorDocuments-tabs">
          <button
            className={`ServitorDocuments-tabBtn ${activeTab === "bio" ? "ServitorDocuments-tabActive" : ""}`}
            onClick={() => setActiveTab("bio")}
          >
            <FaUser className="ServitorDocuments-tabIcon" /> Bio
          </button>
          <button
            className={`ServitorDocuments-tabBtn ${activeTab === "resume" ? "ServitorDocuments-tabActive" : ""}`}
            onClick={() => setActiveTab("resume")}
          >
            <FaFileAlt className="ServitorDocuments-tabIcon" /> Resume
          </button>
          <button
            className={`ServitorDocuments-tabBtn ${activeTab === "student" ? "ServitorDocuments-tabActive" : ""}`}
            onClick={() => setActiveTab("student")}
          >
            <FaIdCard className="ServitorDocuments-tabIcon" /> Student&nbsp;ID
          </button>
        </div>

        <div className="ServitorDocuments-documentViewer">
          {loading && <div className="ServitorDocuments-loading">Loading…</div>}
          {!loading && fetchErr && <div className="ServitorDocuments-error">{fetchErr}</div>}

          {/* BIO */}
          {!loading && !fetchErr && activeTab === "bio" && (
            <div className="ServitorDocuments-tabContent">
              <div className="ServitorDocuments-bioContainer">
                <div className="ServitorDocuments-bioHeader">
                  <div className="ServitorDocuments-avatar">{initials}</div>
                  <div>
                    <h4 className="ServitorDocuments-bioName">
                      {fullServitor?.FirstName} {fullServitor?.LastName}
                    </h4>
                    <p className="ServitorDocuments-bioTitle">
                      Professional {fullServitor?.service || "Servitor"}
                    </p>
                  </div>
                </div>

                <div className="ServitorDocuments-aboutSection">
                  <h5>About Me</h5>
                  {bio ? (
                    bio.split("\n").map((line, i) => (
                      <p key={i} style={{ whiteSpace: "pre-wrap" }}>
                        {line}
                      </p>
                    ))
                  ) : (
                    <p>No bio added yet.</p>
                  )}
                </div>

                {/* Education block (universityName & major) */}
                <div className="ServitorDocuments-eduSection">
                  <h5 className="ServitorDocuments-eduTitle">
                    <FaUserGraduate style={{ marginRight: 8 }} />
                    Education
                  </h5>
                  <div className="ServitorDocuments-eduGrid">
                    <div className="ServitorDocuments-eduItem">
                      <span className="ServitorDocuments-eduLabel">University:</span>
                      <span className="ServitorDocuments-eduValue">
                        {universityName || "N/A"}
                      </span>
                    </div>
                    <div className="ServitorDocuments-eduItem">
                      <span className="ServitorDocuments-eduLabel">Major:</span>
                      <span className="ServitorDocuments-eduValue">
                        {major || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* RESUME */}
          {!loading && !fetchErr && activeTab === "resume" && (
            <div className="ServitorDocuments-tabContent">
              <div className="ServitorDocuments-resumeContainer">
                {hasResume ? (
                  <>
                    <div className="ServitorDocuments-fileMock">
                      <FaFilePdf className="ServitorDocuments-pdfIcon" />
                      <p className="ServitorDocuments-fileName">{resumeName}</p>
                    </div>
                    <div className="ServitorDocuments-actionButtons">
                      <button
                        className="ServitorDocuments-viewPdfBtn"
                        onClick={() => openInNewTab(resumeUrl)}
                      >
                        <FaEye className="ServitorDocuments-btnIcon" /> View PDF
                      </button>
                      <button
                        className="ServitorDocuments-downloadBtn"
                        onClick={() => downloadFile(resumeUrl, resumeName, "resume")}
                        disabled={downloading.resume}
                        aria-busy={downloading.resume}
                      >
                        <FaDownload className="ServitorDocuments-btnIcon" />
                        {downloading.resume ? " Downloading…" : " Download"}
                      </button>
                    </div>
                    {/* {isPdf(resumeUrl) && (
                      <div className="ServitorDocuments-inlinePreview">
                        <iframe
                          src={resumeUrl}
                          title="Resume Preview"
                          className="ServitorDocuments-iframe"
                        />
                      </div>
                    )} */}
                  </>
                ) : (
                  <p>No resume uploaded.</p>
                )}
              </div>
            </div>
          )}

          {/* STUDENT ID */}
          {!loading && !fetchErr && activeTab === "student" && (
            <div className="ServitorDocuments-tabContent">
              <div className="ServitorDocuments-nidContainer">
                <div className="ServitorDocuments-nidHeader">
                  <h5>Student ID Card</h5>
                </div>

                {hasStudentId ? (
                  <>
                    <div className="ServitorDocuments-nidCard">
                      {isImage(studentUrl) ? (
                        <div className="ServitorDocuments-nidImageContainer">
                          <img
                            src={studentUrl}
                            alt="Student ID"
                            className="ServitorDocuments-nidPreviewImg"
                          />
                        </div>
                      ) : isPdf(studentUrl) ? (
                        <div className="ServitorDocuments-inlinePreview">
                          <iframe
                            src={studentUrl}
                            title="Student ID Preview"
                            className="ServitorDocuments-iframe"
                          />
                        </div>
                      ) : (
                        <div className="ServitorDocuments-fileMock">
                          <FaFilePdf className="ServitorDocuments-pdfIcon" />
                          <p className="ServitorDocuments-fileName">{studentName}</p>
                        </div>
                      )}
                    </div>

                    <div className="ServitorDocuments-nidAction">
                      <button
                        className="ServitorDocuments-viewFullBtn"
                        onClick={() => openInNewTab(studentUrl)}
                      >
                        <FaEye className="ServitorDocuments-btnIcon" /> View Full
                      </button>
                      <button
                        className="ServitorDocuments-downloadBtn"
                        onClick={() => downloadFile(studentUrl, studentName, "student")}
                        disabled={downloading.student}
                        aria-busy={downloading.student}
                      >
                        <FaDownload className="ServitorDocuments-btnIcon" />
                        {downloading.student ? " Downloading…" : " Download"}
                      </button>
                    </div>
                  </>
                ) : (
                  <p>No student ID card uploaded.</p>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ServitorDocuments;
